<template>
  <preview-pane :loaded="loaded" :title="customerData && customerData.Name ? customerData.Name : 'Preview customer'">

    <template v-slot:header v-if="showToolbar">
      <v-toolbar dense flat class="minitoolbar">
        <h4 class="nowrapheader" v-text="customerData && customerData.Name ? customerData.Name : 'Preview customer'" />

        <v-spacer />

        <v-btn color="primary" small :to="{ name: 'ViewCustomer', params: { customerId: id } }">
          <v-icon class="mr-2" size="15" v-text="'open_in_full'" />
          {{ $t('servicesystem.common_objects.commonterms.open') }}
        </v-btn>

        <ActionMenu :actionList="actionlist" :parentcontext="thiscontext" class="ml-3">
        </ActionMenu>
      </v-toolbar>
    </template>

    <template v-slot:panels>
      <CustomerDetailsPreview :CustomerData="customerData" :loading="customerLoading" class="mt-3">
      </CustomerDetailsPreview>

      <expanding-list :list="addressData" :title="$t('servicesystem.common_objects.address.addresses')"
        :icon="'mdi-map-marker'" :loading="addressLoading" :cardcount="true">

        <template v-slot:panel-header-outer v-if="customerData && customerData.DefaultDeliveryAddress">
          <v-divider />
          <DeliveryAddressListItem :address="customerData.DefaultDeliveryAddress" :starred="true" :preselected="null"
            class="px-0">
          </DeliveryAddressListItem>
        </template>

        <template slot="list-item" slot-scope="{ item }">
          <DeliveryAddressListItem :address="item" :preselected="null" class="px-0">
          </DeliveryAddressListItem>
        </template>

      </expanding-list>

      <expanding-list :list="contactData" :title="$t('servicesystem.common_objects.contact.contacts')"
        :icon="'mdi-account-tie'" :loading="contactLoading">

        <template slot="panel-header-hint">
          <card-badge :color="'primary'" :count="contactData ? contactData.filter(c => c.IsActive).length : 0"
            :class="'mr-0'">
          </card-badge>
          <card-badge :color="'disabled'" :count="contactData ? contactData.filter(c => !c.IsActive).length : 0"
            :donthide="true" :class="'mr-3'">
          </card-badge>
        </template>

        <template v-slot:panel-header-outer v-if="customerData && customerData.DefaultCustomerPerson">
          <v-divider />
          <ContactListItem :contact="customerData.DefaultCustomerPerson" :starred="true" :preselected="null"
            class="px-0">
          </ContactListItem>
        </template>

        <template slot="list-item" slot-scope="{ item }">
          <ContactListItem :contact="item" :starred="null" :preselected="null" class="px-0">
          </ContactListItem>
        </template>

      </expanding-list>

      <section-header :title="$t('servicesystem.common_objects.job.jobs')"></section-header>

      <UpcomingJobs :id="customerData ? customerData.Id : null" :customer="true" />

      <ActiveJobs :id="customerData ? customerData.Id : null" :customer="true" />

      <ClosedJobs :id="customerData ? customerData.Id : null" :customer="true" />

    </template>
  </preview-pane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import CardBadge from "@/components/Buttons/CardBadge.vue";
import ExpandingList from "@/components/ExpancionPanels/Generic/ExpandingList.vue";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import ContactListItem from "@/components/ListItems/CustomerContactListItem.vue";
import DeliveryAddressListItem from "@/components/ListItems/DeliveryAddressListItem.vue";
import ActiveJobs from "@/components/Preview/ActiveJobsPreview.vue";
import ClosedJobs from "@/components/Preview/ClosedJobsPreview.vue";
import CustomerDetailsPreview from "@/components/Preview/Customer/CustomerDetailsPreview.vue";
import UpcomingJobs from "@/components/Preview/UpcomingJobsPreview.vue";
import PreviewPane from "@/views/layouts/PreviewPane.vue";

import CustomerDetailsEditModel from "@/helpers/Models/Customer-Details-Edit-Model";

export default {
  name: "PreviewCustomer",
  props: ["id", "customer", "showToolbar",],
  components: {
    PreviewPane,
    ExpandingList,
    SectionHeader,
    UpcomingJobs,
    ActiveJobs,
    ClosedJobs,
    ContactListItem,
    DeliveryAddressListItem,
    CustomerDetailsPreview,
    CardBadge,
    ActionMenu,
  },
  mixins: [clientAPI],

  data() {
    return {
      customerData: null,
      addressData: null,
      contactData: null,

      customerLoading: false,
      addressLoading: false,
      contactLoading: false,

      CDmodel: CustomerDetailsEditModel,
      thiscontext: this,
    };
  },

  mounted() {
    this.getAllValues();
  },

  methods: {
    getAllValues() {
      this.getCustomerDetails();
      this.getAddresses();
      this.getContacts();
      //this.getHistory();
    },

    /*
    clearAllValues() {
      this.customerData = null;
      this.addressData = null;
      this.contactData = null;
      this.historyData = null;
    },
    */

    getCustomerDetails() {
      this.customerLoading = true;
      this.getCustomerById(this.id)
        .then((response) => {
          this.customerData = response;
          //console.log("customer:", this.customerData);
        })
        .catch((e) => {
          console.error(e);
          this.customerData = false;
        })
        .finally(() => (this.customerLoading = false));
    },

    getAddresses() {
      this.addressLoading = true;
      this.getCustomerAdressesByCustomerId(this.id)
        .then((response) => {
          this.addressData = response;


        })
        .catch((/*exception*/) => {

          this.addressData = false;
        })
        .finally(() => (this.addressLoading = false));
    },

    getContacts() {
      this.contactLoading = true;
      this.getCustomerContactsByCustomerId(this.id)
        .then((response) => {
          this.contactData = response;


        })
        .catch((/*exception*/) => {

          this.contactData = false;
        })
        .finally(() => (this.contactLoading = false));
    },

    openInNewTab() {
      let newPageRoute = this.$router.resolve({ name: 'ViewCustomer', params: { customerId: this.id } });
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {
    activeAdress() {
      if (!this.customerData) {
        return false;
      } else if (
        this.customerData.DeliveryAdressCountry ||
        this.customerData.DeliveryAdressZip ||
        this.customerData.DeliveryAdressCity ||
        this.customerData.DeliveryAdressName
      ) {
        var adress = {
          country: this.customerData.DeliveryAdressCountry,
          postnr: this.customerData.DeliveryAdressZip,
          city: this.customerData.DeliveryAdressCity,
          adress: this.customerData.DeliveryAdressName,
        };
        return adress;
      } else {
        return false;
      }
    },

    /*
    markedHistory() {
      return this.oddMarkList(this.historyData);
    }, 
    */
    loaded() {
      var result = !this.customerLoading && !this.addressLoading && !this.contactLoading && !this.historyLoading;
      return result;
    },

    actionlist() {
      var list = [
        {
          title: this.$t("servicesystem.common_objects.document.open_in_new_tab"),
          icon: "mdi-open-in-new",
          iconsize: 16,
          hovercolor: "primary",
          method: "openInNewTab",
        },
      ];
      return list;
    },
  },

  watch: {
    id: function () {
      //this.clearAllValues();
      this.getAllValues();
    },
  },
};
</script>